import { render, staticRenderFns } from "./ketcher.vue?vue&type=template&id=ef007bda&scoped=true&"
import script from "./ketcher.vue?vue&type=script&lang=js&"
export * from "./ketcher.vue?vue&type=script&lang=js&"
import style0 from "./ketcher.vue?vue&type=style&index=0&id=ef007bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef007bda",
  null
  
)

export default component.exports